/** Shared types and helpers for the intake submission queue (Sprint 12). */

export type SubmissionStatus = 'new' | 'in_review' | 'converted' | 'rejected';

export const STATUS_LABEL: Record<SubmissionStatus, string> = {
  new: 'New',
  in_review: 'In Review',
  converted: 'Converted',
  rejected: 'Rejected',
};

export const STATUS_COLOR: Record<SubmissionStatus, string> = {
  new: 'bg-blue-50 text-blue-700',
  in_review: 'bg-amber-50 text-amber-700',
  converted: 'bg-green-50 text-green-700',
  rejected: 'bg-slate-100 text-slate-400',
};

export interface Submission {
  id: string;
  formId: string;
  orgId?: string;
  data: Record<string, unknown>;
  submitterEmail?: string | null;
  submitterName?: string | null;
  submitterIp?: string | null;
  linkedAnalysisId?: string | null;
  status: SubmissionStatus;
  assignedTo?: string | null;
  assigneeName?: string | null;
  assigneeEmail?: string | null;
  reviewedAt?: string | null;
  createdAt: string;
}

export interface OrgMember {
  userId: string;
  name: string | null;
  email: string;
  role: string;
}

/**
 * Returns a human-readable age label and whether the submission is urgent
 * (>1 day old and still in an actionable status).
 */
export function formatAge(createdAt: string): { label: string; urgent: boolean } {
  const ms = Date.now() - new Date(createdAt).getTime();
  const mins = Math.floor(ms / 60000);
  if (mins < 60) return { label: `${mins}m ago`, urgent: false };
  const hours = Math.floor(mins / 60);
  if (hours < 24) return { label: `${hours}h ago`, urgent: false };
  const days = Math.floor(hours / 24);
  return { label: `${days}d ago`, urgent: true };
}
